//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */

const Point = require('@mapbox/point-geometry');

exports.modifyMapAndStyle = function (Map, Style) {
    Map.prototype.queryLercData = function () {
        let params = {};
        let geometry;

        if (arguments.length === 2) {
            geometry = arguments[0];
            params = arguments[1];
        } else if (arguments.length === 1 && isPointLike(arguments[0])) {
            geometry = arguments[0];
        } else if (arguments.length === 1) {
            params = arguments[0];
        }

        if (!this.style) {
            return [];
        }

        return this.style.queryLercData(
            this._makeQueryGeometry(geometry),
            params,
            this.transform.zoom,
            this.transform.angle
        );
    };
    Style.prototype.queryLercData = function (queryGeometry, params) {
        const includedSources = {};
        if (params && params.sources) {
            if (!Array.isArray(params.sources)) {
                this.fire('error', { error: 'params.sources must be an array' });
                return;
            }
            for (const sourceId of params.sources) {
                const source = this.sourceCaches[sourceId];
                if (!source) {
                    // this layer is not in the style.layers array
                    this.fire('error', { error: `The source '${sourceId}' does not exist in the map's style and cannot be queried for LercData.` });
                    return;
                }
                includedSources[sourceId] = true;
            }
        }
        const sourceResults = [];
        for (const id in this.sourceCaches) {
            if (params.sources && !includedSources[id]) continue;
            const results = lercData(queryGeometry, this.sourceCaches[id]);
            sourceResults.push(results);
        }
        return sourceResults;

    };
};
function isPointLike(input) {
    return input instanceof Point || Array.isArray(input);
}
function lercData(queryGeometry, sourceCache) {
    const tilesIn = sourceCache.tilesIn(queryGeometry);
    tilesIn.sort(sortTilesIn);
    const lercs = [];
    for (let r = 0; r < tilesIn.length; r++) {
        const tileIn = tilesIn[r];
        if (!tileIn.tile.hasLerc()) continue;

        lercs.push(tileIn.tile.getLerc());
    }
    return { id: sourceCache.id, lercs: lercs };
}

function sortTilesIn(a, b) {
    const coordA = a.tileID.canonical;
    const coordB = b.tileID.canonical;
    return (coordA.z - coordB.z) || (coordA.y - coordB.y) || (coordA.w - coordB.w) || (coordA.x - coordB.x);
}
